const parseJwtPayload = (token: string) => {
  try {
    return JSON.parse(window.atob(token.split(".")[1]));
  } catch (_error) {
    return null;
  }
};

const getCognitoClientId = () => process.env.REACT_APP_CLIENT_ID || "";

const getScopedTokenFromCurrentUser = () => {
  const clientId = getCognitoClientId();
  if (!clientId) return "";

  const lastAuthUserKey = `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`;
  const currentUsername = localStorage.getItem(lastAuthUserKey);
  if (!currentUsername) return "";

  return (
    localStorage.getItem(
      `CognitoIdentityServiceProvider.${clientId}.${currentUsername}.idToken`
    ) || ""
  );
};

export const getStoredIdToken = () => {
  const scopedToken = getScopedTokenFromCurrentUser();
  if (scopedToken) return scopedToken;

  const clientId = getCognitoClientId();
  const clientScopedKeys = clientId
    ? Object.keys(localStorage).filter(
        (key) =>
          key.startsWith(`CognitoIdentityServiceProvider.${clientId}.`) &&
          key.endsWith(".idToken")
      )
    : [];
  const fallbackKeys = Object.keys(localStorage).filter((key) =>
    key.endsWith(".idToken")
  );
  const tokenKeys = clientScopedKeys.length ? clientScopedKeys : fallbackKeys;

  let latestToken = "";
  let latestExp = 0;
  tokenKeys.forEach((key) => {
    const token = localStorage.getItem(key) || "";
    const payload = parseJwtPayload(token);
    const exp = Number(payload?.exp || 0);
    if (exp > latestExp) {
      latestExp = exp;
      latestToken = token;
    }
  });

  return latestToken;
};

export const getHasuraClaimsFromToken = (token: string) => {
  const payload = parseJwtPayload(token);
  if (!payload) return null;

  try {
    return JSON.parse(payload["https://hasura.io/jwt/claims"] || "{}");
  } catch (_error) {
    return null;
  }
};

export const isStoredTokenExpired = (token: string) => {
  const payload = parseJwtPayload(token);
  const exp = Number(payload?.exp || 0);
  return !exp || Date.now() >= exp * 1000;
};

export const isStoredTokenIssuedInFuture = (token: string, skewSeconds = 60) => {
  const payload = parseJwtPayload(token);
  const iat = Number(payload?.iat || 0);
  if (!iat) return false;
  return iat * 1000 > Date.now() + skewSeconds * 1000;
};
